import cx from 'classnames';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let bodymovin: any;

if (__BROWSER__) {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  bodymovin = require('app/client/bodymovin_light');
}

type AnimationProps = {
  animationData: Record<string, unknown>;
  className?: string;
  isInteractive?: boolean;
  playTimer?: number;
  shouldAutoplay?: boolean;
  shouldLoop?: boolean;
  shouldUseLastFrame?: boolean; // used for favorite icon; last frame is filled heart =)
  isPlaying?: boolean;
};

class Animation extends React.Component<AnimationProps> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  animation: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Container: any;

  static defaultProps = {
    isInteractive: false,
    shouldAutoplay: false,
    shouldLoop: false,
    shouldUseLastFrame: false,
    isPlaying: true,
  };

  componentDidMount() {
    const { animationData, isInteractive, playTimer, shouldAutoplay, shouldLoop, shouldUseLastFrame } = this.props;

    this.animation = bodymovin.loadAnimation({
      container: this.Container,
      renderer: 'svg',
      loop: shouldLoop,
      autoplay: shouldAutoplay,
      animationData,
    });

    if (isInteractive && shouldUseLastFrame) {
      this.animation.goToAndStop(this.animation.totalFrames - 1, true);
    }

    if (!shouldAutoplay && playTimer) {
      window.setTimeout(() => {
        this.animation.play();
      }, playTimer);
    }
  }

  componentDidUpdate(prevProps: AnimationProps) {
    const { isInteractive, isPlaying, shouldUseLastFrame } = this.props;

    if (isInteractive && shouldUseLastFrame !== prevProps.shouldUseLastFrame) {
      this.handleAnimate(shouldUseLastFrame);
    }

    if (isPlaying !== prevProps.isPlaying) {
      if (isPlaying) {
        this.animation.play();
      } else {
        this.animation.pause();
      }
    }
  }

  handleAnimate = (shouldUseLastFrame?: boolean) => {
    if (shouldUseLastFrame) {
      this.animation.play();
    } else {
      this.animation.goToAndStop(0);
    }
  };

  render() {
    return (
      <div className={cx('Animation', this.props.className)} ref={(ref) => (this.Container = ref)} aria-hidden="true" />
    );
  }
}

export default Animation;
